import { Optional } from 'utility-types'
import TextFilter, { ITextFilterProps } from './TextFilter'
import { KnockOperator } from '../Knock/KnockTypes'

type DecimalFilterProps = Optional<ITextFilterProps, 'validate' | 'operators'>

const DecimalFilter = (props: DecimalFilterProps) => {
  const validate = /^[0-9]+[.]?[0-9]*$/
  const operators = [
    KnockOperator.EqualTo,
    KnockOperator.GreaterThan,
    KnockOperator.GreatThanOrEqualTo,
    KnockOperator.LessThan,
    KnockOperator.LessThanOrEqualTo
  ]

  return <TextFilter validate={validate} operators={operators} {...props} />
}

export default DecimalFilter
